import React from "react";

// eslint-disable-next-line no-restricted-imports
import { Tabs, TabsRootProps } from "@packages/ds";

import { sendPendoEventTab } from "Store/analytics/pendoFunctions";

const Root = (props: TabsRootProps) => {
  const onTabsValueChange = (tabValue: string) => {
    props.onValueChange?.(tabValue);
    sendPendoEventTab({ analyticId: tabValue });
  };

  return <Tabs.Root {...props} onValueChange={onTabsValueChange} />;
};

export default Root;
